import React from 'react';
import Navbar from '../../components/Navbar2';
import Contact from '../../components/Contact';
import './index.css';

const EatPrayLovePage = () => {
  return (
    <div className="collection-page">
      <Navbar />

      {/* Hero Section */}
      <div
        className="collection-hero"
        style={{
          backgroundImage: "url('https://firebasestorage.googleapis.com/v0/b/phone-auth-d0a8d.appspot.com/o/Luxe%2Fgetty-images-jvXdT-TitTs-unsplash.jpg?alt=media&token=3391aeb1-cccd-456e-bb38-046021a86c3f')",
        }}
      >
        <div className="collection-hero-overlay" />
        <div className="collection-hero-content">
          <p className="collection-hero-label">Collections</p>
          <h1 className="collection-hero-title">Eat Pray Love</h1>
          <p className="collection-hero-sub">
            A journey through flavour, faith, and the art of living well.
          </p>
        </div>
      </div>

      {/* Coming Soon Section */}
      <div className="collection-coming-soon">
        <p className="collection-cs-label">Coming Soon</p>
        <h2 className="collection-cs-title">Launching After India Untamed</h2>
        <p className="collection-cs-text">
          Our Eat Pray Love collection is being carefully curated — a selection of extraordinary properties in destinations that nourish the soul, inspire the spirit, and delight the senses. Stay tuned for an experience unlike any other.
        </p>
        <div className="collection-cs-divider" />
        <p className="collection-cs-notify">
          Register your interest to be notified when this collection launches.
        </p>
      </div>

      <Contact />
    </div>
  );
};

export default EatPrayLovePage;
